import i18next from 'i18next';
import PropTypes from 'prop-types';
import Cookies from 'universal-cookie';
import { supportedLngs } from 'src/i18n';
import { useState, createContext } from 'react';

const DoctorContext = createContext({});

const roleAccess = {
  cases: ['doctor', 'reviews', 'details', 'invites', 'instructions'],
  common: ['patients', 'details', 'redirect', 'invites', 'instructions'],
  'GP admin': ['gp'],
  'Medical staff - doctor': ['doctor', 'screening'],
  'Medical staff - nurse': ['nurse', 'screening'],
};

export const DoctorProvider = ({ children }) => {
  const [currentPatient, setCurrentPatient] = useState(null);
  const [lang, setLang] = useState(i18next.language);
  const [doctor, setDoctor] = useState();
  const cookies = new Cookies();

  const getPermissions = (groups, org) => {
    if (org?.cases_for_review) return [...roleAccess.cases];
    const permissions = [...roleAccess.common];
    groups?.forEach((group) => {
      roleAccess[group]?.forEach((permission) => {
        if (!permissions.includes(permission)) permissions.push(permission);
      });
    });
    return permissions;
  };

  const modifyDoctor = (oldDoctor) => {
    const doula = oldDoctor?.project.slug === 'usa';
    const modifiedDoctor = {
      doula,
      ...oldDoctor,
      displayName: `${oldDoctor?.first_name} ${oldDoctor?.last_name}`,
      access: getPermissions(oldDoctor?.groups, oldDoctor?.organization),
    };

    if (doula) modifiedDoctor.access.push('demo', 'chat');

    // if there was a cached language, don't update with language from doctors profile
    if (!cookies.get('language-cached')) modifyLanguage(modifiedDoctor.language);
    setDoctor(modifiedDoctor);
  };

  const modifyLanguage = (languageInput) => {
    if (languageInput) {
      let language = languageInput.split('-');
      language = language.length > 1 ? `${language[0]}-${language[1].toUpperCase()}` : language[0];

      if (supportedLngs.includes(language)) {
        i18next.changeLanguage(language);
        setLang(language);
      }
    }
  };

  return (
    <DoctorContext.Provider
      value={{
        lang,
        setLang: modifyLanguage,
        doctor,
        setDoctor: modifyDoctor,
        currentPatient,
        setCurrentPatient,
      }}
    >
      {children}
    </DoctorContext.Provider>
  );
};

export default DoctorContext;

DoctorProvider.propTypes = {
  children: PropTypes.any,
};
